function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 499.443 327.394",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 488.66 153.597 C 484.333 147.677 381.233 8.659 249.553 8.659 C 117.877 8.659 14.771 147.677 10.448 153.592 C 6.349 159.208 6.349 166.823 10.448 172.438 C 14.771 178.36 117.877 317.376 249.553 317.376 C 381.233 317.376 484.333 178.356 488.66 172.443 C 492.766 166.828 492.766 159.208 488.66 153.597 Z M 249.553 285.44 C 152.56 285.44 68.55 193.171 43.682 163.007 C 68.519 132.817 152.352 40.596 249.553 40.596 C 346.545 40.596 430.546 132.848 455.426 163.03 C 430.591 193.216 346.758 285.44 249.553 285.44 Z",
    fill: "#304059",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 249.557 67.21 C 196.73 67.21 153.749 110.19 153.749 163.017 C 153.749 215.846 196.73 258.827 249.557 258.827 C 302.384 258.827 345.366 215.846 345.366 163.017 C 345.366 110.19 302.384 67.21 249.557 67.21 Z M 249.557 226.89 C 214.336 226.89 185.684 198.237 185.684 163.017 C 185.684 127.798 214.336 99.147 249.557 99.147 C 284.778 99.147 313.429 127.798 313.429 163.017 C 313.429 198.237 284.778 226.89 249.557 226.89 Z",
    fill: "#304059",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.6c416a2a17a887302171c461de282d80.svg";
export { ForwardRef as ReactComponent };